'use client'

import { useEffect } from 'react'

import { useDocumentationLanguageContext } from '@/shared/components/DocumentationLayoutShell/context/documentationLanguageContext'

interface DocumentationLanguageSyncProps {
  language: string
}

export function DocumentationLanguageSync({ language }: DocumentationLanguageSyncProps) {
  const { setSelectedLanguage } = useDocumentationLanguageContext()

  useEffect(() => {
    if (language) {
      setSelectedLanguage(language)
    }
  }, [language, setSelectedLanguage])

  return null
}
